import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Stack,
  Container,
  useMediaQuery,
} from "@mui/material";
import pic from "../Media/fgfg.jpeg";
import pic2 from "../Media/gfgfg.jpeg";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

export default function OurPlog() {
  const { t } = useTranslation();

  const matches = useMediaQuery("(min-width:600px)");
  const matche = useMediaQuery("(min-width:990px)");
  const isMobile = useMediaQuery("(max-width:780px)");

  const [images, setImages] = useState([
    {
      picture: pic,
      caption:
        "From our participation in the Information and Communications Technology Exhibition (HiTech)",
    },
    {
      picture: pic2,
      caption:
        "From Mashawiri’s participation in the Businessmen and Businesswomen Forum - Servex - the eighth international exhibition for business services",
    },
  ]);

  const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    setActiveStep(0);
  }, [images]);

  const handleStepChange = (index) => {
    setActiveStep(index);
  };

  const handleNext = () => {
    const maxSteps = images.length;
    setActiveStep((prevStep) => (prevStep + 1) % maxSteps);
  };

  const handleBack = () => {
    const maxSteps = images.length;
    setActiveStep((prevStep) => (prevStep - 1 + maxSteps) % maxSteps);
  };

  const maxSteps = images.length;

  return (
    <div>
      <Container sx={{ marginBottom: "100px", marginTop: "100px" }}>
        <Typography
          sx={{
            color: "#1D2877",
            fontWeight: "bold",
            fontSize: "30px",
            marginBottom: "40px",
          }}
        >
          {t("Our blog")}
        </Typography>
        <Stack
          sx={{
            borderRadius: "20px",
            height: matches ? "500px" : "670px",
            boxShadow: "5px 5px 7px 5px #CED9F3  ",
          }}
        >
          <Container sx={{ marginTop: "20px", borderRadius: "20px" }}>
            <Box sx={{ maxWidth: "100%", position: "relative" }}>
              <AutoPlaySwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
              >
                {images &&
                  images.map((step, index) => (
                    <div key={index}>
                      {Math.abs(activeStep - index) <= 2 && (
                        <Stack
                          direction={matche ? "row" : "column"}
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Box sx={{ width: "70%" }}>
                            <Box
                              component="img"
                              sx={{
                                width: matche ? "600px" : "300px",
                                objectFit: "fit",
                                overflow: "hidden",
                                display: "block",
                                height: matche ? 450 : "275px",
                                borderRadius: "20px",
                              }}
                              src={step.picture}
                            ></Box>
                          </Box>

                          <Box
                            sx={{
                              width: matche ? "30%" : "100%",
                              marginTop: matche ? "" : "20px",
                            }}
                          >
                            <Typography
                              sx={{ color: "#1D2877", fontSize: "25px" }}
                            >
                              {step.caption}
                            </Typography>
                          </Box>
                        </Stack>
                      )}
                    </div>
                  ))}
              </AutoPlaySwipeableViews>
              <Button
                sx={{
                  "&:hover": { color: "#1D2877" },
                  position: "absolute",
                  top: matches ? "90%" : "550px",
                  left: matches ? "75%" : "50px",
                  borderRadius: "100px",
                  color: "#1D2877",
                  height: "30px",
                  mt: matche ? "0px" : "40px",
                }}
                size="small"
                onClick={handleNext}
                disabled={activeStep === maxSteps - 1}
              >
                <ArrowBackIosIcon />
              </Button>
              <Button
                sx={{
                  "&:hover": { color: "#1D2877" },
                  position: "absolute",
                  top: matches ? "90%" : "550px",
                  right: matches ? "10%" : "50px",
                  borderRadius: "100px",
                  color: "#1D2877",
                  height: "30px",
                  mt: matche ? "0px" : "40px",
                }}
                size="small"
                onClick={handleBack}
                disabled={activeStep === 0}
              >
                <ArrowForwardIosIcon />
              </Button>
            </Box>
          </Container>
        </Stack>
      </Container>
    </div>
  );
}
